import {
  Checkbox as ChakraCheckbox,
  CheckboxProps as ChakraCheckboxProps,
} from '../../lib/chakraUi/components/Checkbox';
import {
  FormFieldControlledComponent,
  FormFieldControlledComponentProps,
} from '../../types/fields';

type CheckboxProps = ChakraCheckboxProps;

export const Checkbox: FormFieldControlledComponent<CheckboxProps> = ({
  _ref,
  ...props
}: FormFieldControlledComponentProps<unknown, CheckboxProps>) => (
  <ChakraCheckbox ref={_ref} id={props.name} {...props} />
);

Checkbox.controlled = true;
Checkbox.displayName = 'Checkbox';
